import {EnvEnum, Language} from "modules/enums";

function envOrEmpty(key: string) {
	return process.env[key] || "";
}

/**
 * Environment variables
 */
export const API_URL = envOrEmpty("REACT_APP_API_URL");
export const PUBLIC_URL = envOrEmpty("PUBLIC_URL");
export const JSON_URL = envOrEmpty("REACT_APP_JSON_URL");
export const HELP_JSON_URL = `${envOrEmpty("REACT_APP_GZ_LINK")}help_center/`;
export const LOCALES_URL = envOrEmpty("REACT_APP_LOCALE_URL");
export const BASE_URL = envOrEmpty("REACT_APP_BASE_URL");
export const GAME_ZONE_URL = envOrEmpty("REACT_APP_GZ_LINK");
export const ALL_STAR_URL = `${PUBLIC_URL}/`;
export const IS_RELOAD_BLOCK_DISABLED = JSON.parse(
	process.env.REACT_APP_IS_RELOAD_BLOCK_DISABLED ?? "false"
) as boolean;
export const IS_PLAYER_MODAL_DISABLED = JSON.parse(
	process.env.REACT_APP_IS_PLAYER_MODAL_DISABLED ?? "false"
) as boolean;
export const IS_FAN_VOTE_DISABLED = process.env.REACT_APP_IS_FAN_VOTE_HIDDEN === "true";

export const FB_SHARE_URL = envOrEmpty("REACT_APP_FB_SHARE_URL");
export const ENVIRONMENT = envOrEmpty("REACT_APP_ENVIRONMENT") as EnvEnum;
export const IMAGES_URL = envOrEmpty("REACT_APP_IMAGES_URL");
export const OTHER_LANG_LINK = envOrEmpty("REACT_APP_OTHER_LANG_LINK");

export const UAT_URL_EN = "https://cfl-gamezone.uat.f2p.media.geniussports.com";
export const UAT_URL_FR = "https://lcf-zonejeux.uat.f2p.media.geniussports.com";
export const PREPROD_URL_EN = "https://cfl-gamezone.preprod.f2p.media.geniussports.com";
export const PREPROD_URL_FR = "https://lcf-zonejeux.preprod.f2p.media.geniussports.com";
export const PROD_URL_EN_INTERNAL = "https://cfl-gamezone.us.f2p.media.geniussports.com";
export const PROD_URL_FR_INTERNAL = "https://lcf-zonejeux.us.f2p.media.geniussports.com";
export const PROD_URL_EN = "https://gamezone.cfl.ca";
export const PROD_URL_FR = "https://zonejeux.lcf.ca";
export const IS_LOC = window.location.href.includes(".loc");

export const SENTRY_DOMAIN_ALLOWED = ".f2p.media.geniussports.com";
export const GAMEZONE_URLS = {
	[Language.English]: "https://www.cfl.ca/",
	[Language.French]: "https://www.lcf.ca/",
};

export const SOCIAL_URLS = {
	[Language.English]: {
		facebook: "https://www.facebook.com/CFL",
		twitter: "https://twitter.com/CFL",
	},
	[Language.French]: {
		facebook: "https://www.facebook.com/LCF",
		twitter: "https://twitter.com/LCFca",
	},
};

export const DOMAINS_MAPPER = {
	[Language.English]: {
		[EnvEnum.Development]: UAT_URL_EN,
		[EnvEnum.PreProd]: PREPROD_URL_EN,
		[EnvEnum.Production]: PROD_URL_EN,
	},
	[Language.French]: {
		[EnvEnum.Development]: UAT_URL_FR,
		[EnvEnum.PreProd]: PREPROD_URL_FR,
		[EnvEnum.Production]: PROD_URL_FR,
	},
};
